import { gql } from '@apollo/client';

export const GET_ALL_TENANT_FEATURE_FLAGS = gql`
  query GetAllTenantFeatureFlags($input: GetFeatureFlagsInput!) {
    getFeatureFlags(input: $input) {
      featureFlags {
        key
        value {
          status
        }
      }
    }
  }
`;
